<template>
  <div class="staff-edit" v-if="dataPermission && dataPermission.includes('CNPS_SUR_STAFF_UPSERT')">
    <div class="breadcrumb-area pos-relative" style="width: 100%">
      <h1>Thêm mới nhân viên</h1>
      <div style="float: right">
        <button
          class="f12 font-medium btn btn-primary rounded-pill btn-sm-fix btn-link"
          @click="addStaff"
        >
          <i class="bx bx-plus-circle"></i> Thêm mới
        </button>
        <button
          class="f12 ml-2 font-medium btn btn-outline-secondary rounded-pill"
          @click="$router.push('/staff')"
        >
          <i class="bx bx-arrow-back"></i> Quay lại
        </button>
      </div>
    </div>
    <!-- End Breadcrumb Area -->
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <ValidationObserver ref="formAdd">
        <div class="card-body">
          <form @submit.prevent="addStaff" class="row">
            <div class="col-md-4">
              <h4 class="form-inner-heading">Cá nhân</h4>
              <ValidationProvider rules="required|minMAxName" vid="name" name="Họ và tên">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Họ và tên<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-7">
                    <input v-model="dataInsert.name" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required|mail_3" vid="userName" name="Email">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Email<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-7">
                    <input v-model.trim="dataInsert.userName" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="dateOfBirth" name="Ngày tháng năm sinh">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Ngày tháng năm sinh</label>
                  <div class="col-sm-7">
                    <datepicker
                      format="dd/MM/yyyy"
                      :language="vi"
                      v-model="dataInsert.dateOfBirth"
                    ></datepicker>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="regexNumber" vid="identifyCard" name="Số CMND/CCCD/HC">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Số CMND/CCCD/HC</label>
                  <div class="col-sm-7">
                    <input v-model="dataInsert.identifyCard" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="timeRange" name="Ngày cấp">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Ngày cấp</label>
                  <div class="col-sm-7">
                    <datepicker
                      format="dd/MM/yyyy"
                      :language="vi"
                      v-model="dataInsert.timeRange"
                    ></datepicker>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="place" name="Nơi cấp">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Nơi cấp</label>
                  <div class="col-sm-7">
                    <input v-model="dataInsert.place" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="gender" name="Giới tính">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Giới tính<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-7">
                    <Select2 v-model="dataInsert.gender" :options="dataConfigGender"> </Select2>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="mobile" name="Số điện thoại">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Số điện thoại<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-7">
                    <input v-model.trim="dataInsert.mobile" type="text" class="form-control" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="address" name="Địa chỉ">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Địa chỉ</label>
                  <div class="col-sm-7">
                    <input v-model="dataInsert.address" type="text" class="form-control" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="levelEmployee" name="Cấp bậc nhân viên">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Cấp bậc nhân viên<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-7">
                    <Select2
                      v-model="dataInsert.levelEmployee"
                      :options="dataLevelEmployee"
                    ></Select2>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-4">
              <h4 class="form-inner-heading">Công ty</h4>
              <ValidationProvider
                rules="required|regexNumber"
                vid="companyCode"
                name="Mã nhân viên"
              >
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Mã nhân viên<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-7">
                    <input v-model="dataInsert.companyCode" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="companyDayIn" name="Ngày vào công ty">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Ngày vào công ty <span class="ml-1" style="color: red">*</span></label
                  >
                  <div class="col-sm-7">
                    <datepicker
                      format="dd/MM/yyyy"
                      :language="vi"
                      v-model="dataInsert.companyDayIn"
                      placeholder="Chọn ngày vào công ty"
                    ></datepicker>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="officialTime" name="Ngày lên chính thức">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Ngày lên chính thức</label>
                  <div class="col-sm-7">
                    <datepicker
                      format="dd/MM/yyyy"
                      :language="vi"
                      v-model="dataInsert.officialTime"
                      placeholder="Chọn ngày lên chính thức"
                    ></datepicker>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="signContractTime" name="Ngày ký HĐLĐ">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Ngày ký HĐLĐ</label>
                  <div class="col-sm-7">
                    <datepicker
                      format="dd/MM/yyyy"
                      :language="vi"
                      v-model="dataInsert.signContractTime"
                      placeholder="Chọn ngày ký HĐLĐ"
                    ></datepicker>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="contractPeriod" name="Thời hạn HĐ">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Thời hạn HĐ</label>
                  <div class="col-sm-7">
                    <Select2 v-model="dataInsert.contractPeriod" :options="optionPeriod"></Select2>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="resignDate" name="Ngày nghỉ việc">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Ngày nghỉ việc</label>
                  <div class="col-sm-7">
                    <datepicker
                      format="dd/MM/yyyy"
                      :language="vi"
                      v-model="dataInsert.resignDate"
                      placeholder="Chọn ngày nghỉ việc"
                    ></datepicker>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider
                rules="regexNumber2"
                vid="leaveDay"
                name="Số ngày nghỉ phép còn lại"
              >
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Số ngày nghỉ phép còn lại</label>
                  <div class="col-sm-7">
                    <input v-model="dataInsert.leaveDay" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="typeSale" name="Vai trò">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Vai trò<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-7">
                    <Select2 v-model="dataInsert.typeSale" :options="dataRole" :disabled="true" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="companyPhase" name="Vị trí">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Vị trí<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-7">
                    <Select2 v-model="dataInsert.companyPhase" :options="optionComphase"></Select2>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="superior" name="Người quản lý">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Người quản lý<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-7">
                    <!-- <select2
                    v-model="dataInsert.superior"
                    :options="dataManager"
                  /> -->
                    <select2
                      v-model="dataInsert.superior"
                      :settings="superiorSettings"
                      placeholder="Tìm kiếm người quản lý"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="region" name="Vùng">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Vùng<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-7">
                    <select2-multiple-control
                      @change="
                        queryProvince($event),
                          checkMainHasValue(dataInsert, 'regionMain', dataInsert.region)
                      "
                      v-model="dataInsert.region"
                      :options="dataRegion"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="regionMain" name="Vùng chính">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Vùng chính<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-7">
                    <Select2
                      v-model="dataInsert.regionMain"
                      :options="filterSelected(dataInsert.region, dataRegion)"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="province" name="Tỉnh/Thành phố">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Tỉnh/Thành phố<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-7">
                    <select2-multiple-control
                      v-model="dataInsert.province"
                      :options="dataProvince"
                      @change="
                        convertDataProvice($event),
                          checkMainHasValue(dataInsert, 'provinceMain', dataInsert.province)
                      "
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                    <!-- <p class="text-danger">{{ errorProvince }}</p> -->
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="provinceMain" name="Tỉnh/Thành phố chính">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Tỉnh/Thành phố chính<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-7">
                    <Select2
                      v-model="dataInsert.provinceMain"
                      :options="filterSelected(dataInsert.province, dataProvince)"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="lead" name="Leads/Ngày">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Leads/Ngày</label>
                  <div class="col-sm-7">
                    <input
                      type="number"
                      min="1"
                      class="form-control"
                      v-model="dataAddKPI.lead"
                      @input="checkValueKpi()"
                      placeholder="Leads/ngày"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="work" name="Công việc/Ngày">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Công việc/Ngày</label>
                  <div class="col-sm-7">
                    <input
                      type="number"
                      class="form-control"
                      min="1"
                      v-model="dataAddKPI.work"
                      @input="checkValueKpi()"
                      placeholder="Công việc/ngày"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="kpi" name="KPI/Tháng">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">KPI/Tháng</label>
                  <div class="col-sm-7">
                    <input
                      type="number"
                      class="form-control"
                      min="1"
                      v-model="dataAddKPI.kpi"
                      @input="checkValueKpi()"
                      placeholder="KPI/tháng"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-4">
              <h4 class="form-inner-heading">Ảnh</h4>
              <h4 class="form-inner-heading">Ảnh nhân viên</h4>
              <div class="form-group img-list">
                <ul class="m-0">
                  <li v-for="(item, index) in avtArr" :key="index">
                    <a href="#">
                      <img :src="item.url" />
                      <span @click="removeImg(item.id)">
                        <i class="bx bx-trash bx-sm"></i>
                      </span>
                    </a>
                  </li>
                  <li>
                    <div
                      v-if="loadingImage"
                      class="add-img d-flex align-content-center justify-content-center"
                    >
                      <div class="text-center">
                        <i class="bx bx-loader-circle bx-spin bx-rotate-90 h1"></i>
                      </div>
                    </div>
                    <div v-else-if="avtArr && avtArr.length < 1" class="add-img">
                      <span class="bx bx-plus text-center"></span>
                      <input
                        accept="image/jpeg, image/png"
                        type="file"
                        ref="fileInput"
                        @change="selectImage($event, 'avtArr')"
                      />
                    </div>
                  </li>
                </ul>
              </div>
              <h4 class="form-inner-heading">Ảnh chứng chỉ</h4>
              <div class="form-group img-list">
                <ul class="m-0">
                  <li v-for="(item, index) in certificateArr" :key="index">
                    <a href="#">
                      <img :src="item.url" />
                      <span @click="removeImg(item.id)">
                        <i class="bx bx-trash bx-sm"></i>
                      </span>
                    </a>
                  </li>
                  <li>
                    <div
                      v-if="loadingImage"
                      class="add-img d-flex align-content-center justify-content-center"
                    >
                      <div class="text-center">
                        <i class="bx bx-loader-circle bx-spin bx-rotate-90 h1"></i>
                      </div>
                    </div>
                    <div v-else-if="certificateArr && certificateArr.length < 5" class="add-img">
                      <span class="bx bx-plus text-center"></span>
                      <input
                        accept="image/jpeg, image/png"
                        type="file"
                        ref="fileInput"
                        @change="selectImage($event, 'certificateArr')"
                      />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </form>
        </div>
      </ValidationObserver>
    </div>

    <b-modal id="modal-scoped" centered v-model="showModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <button type="button" class="close" @click="close()">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <div class="modal-body text-center">
        <img src="@/assets/noti-success2.svg" alt="icon-successs" />
        <h2 class="f18 py-3">Thêm mới thành công</h2>
        <p class="text-center">Nhân viên: {{ insertSuccess.name }}</p>
        <p class="text-center">Email: {{ insertSuccess.userName }}</p>
        <p class="text-center">Mật khẩu mới: {{ insertSuccess.password }}</p>
      </div>
      <template #modal-footer="{}">
        <b-button variant="light" @click="$router.push('/staff')"> Đóng </b-button>
      </template>
    </b-modal>

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import Config from '../../thirdParty/config'
  import { StaffService } from '@/services/staff.service'
  import { mapGetters } from 'vuex'
  import { CommonService } from '@/services/common.service'
  import { vi } from 'vuejs-datepicker/dist/locale'
  import { v4 as uuidv4 } from 'uuid'
  import reuseMx from './reuseMx.js'
  import { SearchStaff } from '@/services/customer-support/staff'
  import { showMess } from '@/config/utils'

  export default {
    mixins: [reuseMx],
    data() {
      return {
        dataInsert: {
          province: [],
          kpiReq: {},
          leaveDay: '',
          typeSale: 'COOPERATOR',
        },
        vi: vi,
        dataLevelEmployee: Config.levelEmployee,
        dataConfigGender: Config.configGender,
        optionComphase: Config.optionComphase,
        optionPeriod: Config.contractPeriod,
        dataRegion: [],
        dataProvince: [],
        objectMesserr: {},
        // dataManager: [],
        showModal: false,
        insertSuccess: {},
        dataRole: [],
        messErr: '',
        dataAddKPI: {
          kpi: null,
          lead: null,
          work: null,
        },
        showLoading: false,
        // provinceSelectedData: [],
        arrayUpload: [],
        loadingImage: false,
        errorProvince: '',

        tLoadSuperior: undefined,
        superiorSettings: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              // if (!txtSearch) {
              //   return success({
              //     results: [],
              //   });
              // }

              if (this.tLoadSuperior) {
                clearTimeout(this.tLoadSuperior)
              }

              this.tLoadSuperior = setTimeout(() => {
                SearchStaff({
                  keyWord: txtSearch,
                  limit: 10,
                })
                  .then(res => {
                    if (res.code == 1000) {
                      success({
                        results: res.data.map(user => {
                          return {
                            id: user.userName,
                            text: user.name || user.userName,
                          }
                        }),
                      })
                    } else {
                      showMess(
                        this,
                        'Thông báo',
                        res?.data?.message || res.message,
                        'danger',
                        'b-toaster-top-right',
                        5 * 60 * 60
                      )
                    }
                  })
                  .catch(error => {
                    showMess(
                      this,
                      'Thông báo',
                      error?.response?.message || error.message,
                      'danger',
                      'b-toaster-top-right',
                      5 * 60 * 60
                    )
                  })
              }, 500)
            },
          },
        },
      }
    },

    computed: {
      ...mapGetters({
        dataEdit: 'user/dataEditStaff',
        dataPermission: 'role/dataPermission',
      }),
      avtArr: vm => vm.arrayUpload.filter(e => e.nameFile === 'avtArr'),
      certificateArr: vm => vm.arrayUpload.filter(e => e.nameFile === 'certificateArr'),
    },

    async created() {
      // this.superiors()
      if (this.dataEdit.name) {
        const dataQuery = await StaffService.getStaffById({
          userId: this.dataEdit.id,
        })
        if (dataQuery.success) {
          this.dataInsert = dataQuery.data
          this.dataInsert.userName = this.dataInsert.username
          this.queryProvince(this.dataInsert.region)
        }
      }
      this.getRegion()
      this.getTypeSale()
    },

    methods: {
      async selectImage(e, nameFile) {
        const file = e.target.files[0]
        if (file.size > 20 * 1024 * 1024) {
          alert('Upload tối đa 20MB')
          return
        }
        this.arrayUpload.push({ id: uuidv4(), url: URL.createObjectURL(file), file, nameFile })
        this.$refs[nameFile].value = null
      },

      removeImg(id) {
        this.arrayUpload = this.arrayUpload.filter(s => s.id !== id)
      },

      async uploadS3(data) {
        try {
          const formData = new FormData()
          formData.append('files', data.file)
          formData.append('folderName', 'NextCrm')
          const res = await CommonService.uploadImg(formData)
          if (res.success) {
            return { url: res.data[0], nameFile: data.nameFile }
          }
        } catch (error) {
          showMess(
            this,
            'Thông báo',
            error?.response?.message || error.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },

      async submitImage() {
        this.dataInsert.avatarUrl = []
        this.dataInsert.certificateImages = []
        const imagePromise = this.arrayUpload.map(el => this.uploadS3(el))
        return Promise.allSettled(imagePromise).then(
          res =>
            res.forEach(e => {
              if (e.status === 'fulfilled') {
                if (e.value.nameFile === 'avtArr') {
                  this.dataInsert.avatarUrl.push(e.value.url)
                }
                if (e.value.nameFile === 'certificateArr') {
                  this.dataInsert.certificateImages.push(e.value.url)
                }
              }
            })
          // return
        )
      },

      // async superiors () {
      //   try {
      //     const data = await StaffService.superiors()
      //     if (data.data.length > 0) {
      //       this.dataManager = data.data.map(e => {
      //         return {
      //           id: e.userName,
      //           text: e.name
      //         }
      //       })
      //     }
      //   } catch (error) {}
      // },
      async getTypeSale() {
        // try {
        //   const data = await CommonService.getTypeSale({})
        //   if (data.data.length > 0) {
        //     this.dataRole = data.data.map(e => {
        //       return {
        //         id: e.code,
        //         text: e.name
        //       }
        //     })
        //   }
        // } catch (error) {}
        this.dataRole = [
          {
            id: 'COOPERATOR',
            text: 'CTV Kinh Doanh',
          },
        ]
      },
      async getRegion() {
        try {
          const data = await StaffService.getRegions()
          if (data.data.length > 0) {
            this.dataRegion = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
          }
        } catch (error) {
          showMess(
            this,
            'Thông báo',
            error?.response?.message || error.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },
      async queryProvince(e) {
        try {
          const data = await StaffService.getProvinceRegion({
            regionId: e,
          })
          if (data.data.length > 0) {
            this.dataProvince = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.dataProvince.unshift({ id: 'ALL', text: 'Tất cả' })
          } else {
            delete this.dataInsert.region
            delete this.dataInsert.province
            this.dataProvince = []
          }
        } catch (error) {
          showMess(
            this,
            'Thông báo',
            error?.response?.message || error.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },
      convertDataProvice(e) {
        if (e?.length === 0) {
          delete this.dataInsert.province
          this.errorProvince = ''
        } else {
          if (e.includes('ALL')) this.dataInsert.province = ['ALL']
        }
      },

      closeModalAdd() {
        this.showModal = false
        this.$router.push('/staff')
      },
      async addStaff() {
        if (this.dataInsert.province?.length > 0) {
          if (this.dataInsert.province.includes('ALL')) {
            const dataProvince = this.dataProvince?.filter(e => e.id !== 'ALL')
            this.dataInsert.province = dataProvince?.map(e => {
              return e.id
            })
          }
        } else {
          delete this.dataInsert.province
          this.errorProvince = 'Tỉnh/Thành phố không được để trống'
        }
        // check provinceMain and regionMain
        const provinceList = this.dataProvince?.map(e => e.id)
        this.dataInsert.province = this.dataInsert.province?.filter(p => provinceList.includes(p))
        this.checkMainHasValue(this.dataInsert, 'regionMain', this.dataInsert.region)
        this.checkMainHasValue(this.dataInsert, 'provinceMain', this.dataInsert.province)
        await this.$nextTick()

        const isSuccess = await this.$refs.formAdd.validate()
        if (!isSuccess) {
          return
        }
        if (this.dataInsert.leaveDay !== '') {
          const check = /^[0-9]+(\.[0-9]+)?$/.test(this.dataInsert.leaveDay)
          if (!check) {
            return
          }
        }
        const submit = await this.approveMx('Bạn chắc chắn thêm nhân viên này?')
        if (submit) {
          this.submitInsert()
        }
      },
      async submitInsert() {
        try {
          this.showLoading = true
          await this.submitImage()
          this.dataInsert.avatarUrl = this.dataInsert.avatarUrl[0]
          this.convertDataBeforeSubmit()
          const data = await StaffService.addStaff(this.dataInsert)

          if (data.data.result) {
            this.insertSuccess = {
              name: data.data.data.name,
              userName: data.data.data.userName,
              password: data.data.data.password,
            }
            this.showModal = true
          } else {
            this.showFailMx(data.data.message)
          }
        } catch (error) {
          showMess(
            this,
            'Thông báo',
            error?.response?.message || error.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.showLoading = false
        }
      },

      convertDataBeforeSubmit() {
        this.dataInsert.companyDayIn = new Date(this.dataInsert.companyDayIn).getTime()
        this.dataInsert.dateOfBirth = new Date(this.dataInsert.dateOfBirth).getTime()

        if (this.dataInsert.signContractTime)
          this.dataInsert.signContractTime = new Date(this.dataInsert.signContractTime).getTime()
        if (this.dataInsert.officialTime)
          this.dataInsert.officialTime = new Date(this.dataInsert.officialTime).getTime()
        if (this.dataInsert.companyDayIn)
          this.dataInsert.companyDayIn = new Date(this.dataInsert.companyDayIn).getTime()
        if (this.dataInsert.timeRange)
          this.dataInsert.timeRange = new Date(this.dataInsert.timeRange).getTime()
        if (this.dataInsert.resignDate)
          this.dataInsert.resignDate = new Date(this.dataInsert.resignDate).getTime()
        if (this.dataInsert.levelEmployee)
          this.dataInsert.levelEmployee = Number(this.dataInsert.levelEmployee)

        if (!this.dataAddKPI.kpi && !this.dataAddKPI.lead && !this.dataAddKPI.work) {
          this.dataInsert.kpiReq = {}
        } else {
          this.dataAddKPI.kpi
            ? (this.dataInsert.kpiReq.kpi = Number(this.dataAddKPI.kpi))
            : delete this.dataInsert.kpiReq.kpi
          this.dataAddKPI.lead
            ? (this.dataInsert.kpiReq.lead = Number(this.dataAddKPI.lead))
            : delete this.dataInsert.kpiReq.lead
          this.dataAddKPI.work
            ? (this.dataInsert.kpiReq.work = Number(this.dataAddKPI.work))
            : delete this.dataInsert.kpiReq.work
        }
      },

      checkValueKpi() {
        if (Number(this.dataAddKPI.lead) === 0) this.dataAddKPI.lead = null
        if (Number(this.dataAddKPI.work) === 0) this.dataAddKPI.work = null
        if (Number(this.dataAddKPI.kpi) === 0) this.dataAddKPI.kpi = null
      },
    },
  }
</script>

<style scoped>
  .col-form-label {
    padding-top: calc(0.375rem + 1px);
    padding-bottom: calc(0.375rem + 1px);
    margin-bottom: 0;
    font-size: inherit;
    line-height: 1.5;
  }

  .form-inner-heading {
    font-size: 16px;
    padding-bottom: 20px;
  }

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }
</style>
